import React from 'react';

import NewsEditForm from './NewsEditForm';
import { News } from '../../../Data/Classes';

function NewsCreatePage(props) {
    const news = new News(0, "", "", "", "", false, false);

    return (
        <>
            <h1>Hír létrehozása</h1>
            <NewsEditForm news={news} />
        </>
    );
}

export default NewsCreatePage;
